import React from 'react'
import { View, TouchableWithoutFeedback, Dimensions } from 'react-native'

import { ViewPropTypes } from 'deprecated-react-native-prop-types'
import PropTypes from 'prop-types'

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components'
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import { getThemeImages } from '../../Themes/Modes'

import styles from './ServiceCard.style'

const ServiceCard = ({
  id,
  serviceIcon,
  title,
  titleStyle,
  subtitle,
  subtitleStyle,
  description,
  descriptionStyle,
  containerStyle,
  onServiceItemPress,
  ...props
}) => {
  const theme = useTheme()
  const images = getThemeImages(theme.name)

  if (Dimensions.get('window').width > 700) {
    return (
      <TouchableWithoutFeedback
        onPress={() =>
          onServiceItemPress({
            id,
            serviceIcon,
            title,
            subtitle,
            description,
            ...props,
          })
        }
      >
        <View style={[styles.container(theme), containerStyle, { cursor: 'pointer' }]}>
          <View style={styles.serviceIconAndContentContainer}>
            <Icon name={images[serviceIcon]} style={styles.serviceIcon} />
            <View style={styles.titleAndSubtitleContainer}>
              <VFText i18nKey={title} style={[styles.title(theme), titleStyle]} />
              <VFText i18nKey={subtitle} style={[styles.subtitle(theme), subtitleStyle]} />
              <VFText i18nKey={description} style={[styles.description(theme), descriptionStyle]} />
            </View>

            <Icon name={images.ic_chevron_right_red} size={30} />

          </View>
        </View>
      </TouchableWithoutFeedback>
    )
  }
  return (
    <TouchableWithoutFeedback
      onPress={() =>
        onServiceItemPress({
          id,
          serviceIcon,
          title,
          subtitle,
          description,
          ...props,
        })
      }
    >
      <View style={[styles.container(theme), containerStyle]}>
        <View style={styles.serviceIconAndContentContainer}>
          <Icon name={images[serviceIcon]} style={styles.serviceIcon} />
          <View style={styles.titleAndSubtitleContainer}>
            <VFText i18nKey={title} style={[styles.title(theme), titleStyle]} />
            <VFText i18nKey={subtitle} style={[styles.subtitle(theme), subtitleStyle]} />
          </View>

          <Icon name={images.ic_chevron_right_red} size={30} />
        </View>
        <View>
          <VFText i18nKey={description} style={[styles.description(theme), descriptionStyle]} />
        </View>
      </View>
    </TouchableWithoutFeedback>
  )
}

ServiceCard.propTypes = {
  id: PropTypes.number,
  serviceIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  title: PropTypes.string,
  titleStyle: ViewPropTypes.style,
  subtitle: PropTypes.string,
  subtitleStyle: ViewPropTypes.style,
  description: PropTypes.string,
  descriptionStyle: ViewPropTypes.style,
  containerStyle: ViewPropTypes.style,
  onServiceItemPress: PropTypes.func,
}

export default ServiceCard
